import type { TFunction } from "i18next";
import { u3125FormatCurrency } from "../../../../../u3125Facture/U3125";
import { u3125FormatWipTransactionKindLabel } from "../../../../../u3125Facture/U3125Service";
import { NS } from "../../../../U3121";
import type { U3121BillingKindAggregate } from "../../../../U3121Service";

interface U3121BillingSummaryKindBreakdownProps {
  byKind: U3121BillingKindAggregate[];
  t: TFunction;
}

function U3121BillingSummaryKindBreakdown({ byKind, t }: U3121BillingSummaryKindBreakdownProps) {
  if (!byKind.length) return null;

  return (
    <table className="mt-2 w-full text-xs">
      <thead>
        <tr className="text-left text-muted-foreground">
          <th className="pb-1 font-medium">{t("colBillingSummaryKind", { ns: NS })}</th>
          <th className="pb-1 text-right font-medium">{t("lblLineCount", { ns: NS })}</th>
          <th className="pb-1 text-right font-medium">{t("lblTotalAmount", { ns: NS })}</th>
          <th className="pb-1 text-right font-medium">{t("lblTotalCostAmount", { ns: NS })}</th>
        </tr>
      </thead>
      <tbody>
        {byKind.map((row, idx) => (
          <tr key={`${row.kind ?? "kind"}-${idx}`} className="border-t border-gray-100">
            <td className="py-1">{u3125FormatWipTransactionKindLabel(row.kind, t, NS)}</td>
            <td className="py-1 text-right tabular-nums">{row.lineCount ?? 0}</td>
            <td className="py-1 text-right tabular-nums">{u3125FormatCurrency(row.totalAmount)}</td>
            <td className="py-1 text-right tabular-nums">{u3125FormatCurrency(row.totalCostAmount)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default U3121BillingSummaryKindBreakdown;
